import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "./url";

const getApiErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.Message ||
  error?.message ||
  "Something went wrong";

export const updateService = (form) => {
  return new Promise(async (resolve) => {
    try {
      const token = Cookies.get("Bearer");
      const firm = await axios.get(`${FIRMFLOWURL}api/Firm`, {
        headers: { Authorization: token },
      });

      const response = await axios.put(
        `${FIRMFLOWURL}api/Service/firm/${firm.data.id}/service/${form.id}`,
        {
          name: form.name,
          departmentId: form.departmentId,
          jobId: form.jobId,
          stepMappings: form.stepMappings,
          isEfileStatusActive: form.isEfileStatusActive,
          description: form.description,
          category: form.category,
        },
        {
          headers: { Authorization: token },
        }
      );
      resolve({ ...response });
    } catch (err) {
      console.log(err);
      if (err.message.includes(401)) {
        Cookies.remove("Bearer");
        window.location.replace("/");
        return;
      }
      const message = getApiErrorMessage(err);
      resolve({
        success: false,
        data: {
          success: false,
          message,
        },
      });
    }
  });
};
